// removed by extract-text-webpack-plugin
module.exports = {"base":"Dialog_base--2ONXr","isOpened":"Dialog_isOpened--3ml9e","wrapper":"Dialog_wrapper--2fg9V","body":"Dialog_body--1EqHK","background":"Dialog_background--hpymD","header":"Dialog_header--1wtRV","title":"Dialog_title--1FOqf","close":"Dialog_close--xjJ2h","content":"Dialog_content--1wibj","footer":"Dialog_footer--10Xv5","button":"Dialog_button--3rU3t","overlay":"Dialog_overlay--3nZpG"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Dialog/Dialog.css
// module id = 1756
// module chunks = 16